import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { useTranslation } from "react-i18next";
import { getLadderColor } from "../../util/HelperUtils";
import type { CSSProperties } from "react";

const LADDER_OPTIONS = [
  { id: 1, key: 'advanced', labelKey: 'advancedLadder' },
  { id: 2, key: 'intermediate', labelKey: 'intermediateLadder' },
  { id: 3, key: 'beginners', labelKey: 'beginnerLadder' },
];

interface LadderFilterButtonsProps {
  selectedLadderId: number | null;
  onLadderChange: (ladderId: number) => void;
  availableLadders?: number[] | null;
}

function LadderFilterButtons({ selectedLadderId, onLadderChange, availableLadders = null }: LadderFilterButtonsProps) {
  const { t } = useTranslation();

  const getFilterButtonStyle = (ladderId: number, isActive: boolean): CSSProperties => {
    if (!isActive) return {};
    const color = getLadderColor(ladderId);
    return {
      backgroundColor: color,
      borderColor: color,
      color: '#000'
    };
  };

  const ladders = availableLadders
    ? LADDER_OPTIONS.filter(l => availableLadders.includes(l.id))
    : LADDER_OPTIONS;

  return (
    <ButtonGroup className="ladder-filter-buttons">
      {ladders.map(ladder => {
        const isActive = selectedLadderId === ladder.id;
        return (
          <Button
            key={ladder.id}
            variant={isActive ? 'primary' : 'outline-secondary'}
            onClick={() => onLadderChange(ladder.id)}
            className="ladder-filter-btn"
            style={getFilterButtonStyle(ladder.id, isActive)}
          >
            {t(ladder.labelKey)}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}

export default LadderFilterButtons;
